import React, { useState, useEffect, useRef } from 'react';
import './IntegerInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';

export default function IntegerInput({ initialValue, rules, onValidate, name, label, instructions, showError, errorMessages, readOnly, tabIndex }) {
  const [value, setValue] = useState((initialValue ? initialValue : ''));
  const [isValid, setIsValid] = useState(null);
  const [validationDetails, setValidationDetails] = useState(null);
  const fieldIsValid = isValid; 

  if (logComponent('IntegerInput')) { console.debug('IntegerInput rendered'); }


  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('IntegerInput')) { console.debug('IntegerInput setNativeCheckboxRef'); }
    validateThis();
  }, []);


  const valueRef = useRef((initialValue ? initialValue : ''));


  const setValueRef = (el) => {
    if (logComponent('IntegerInput')) { console.debug('IntegerInput setValueRef'); }
    valueRef.current = el;
    setValue(el);
  }

 
  const updateValue = (e) => {
    if (logComponent('IntegerInput')) { console.debug('IntegerInput updateValue'); }
    setValueRef(e.target.value);
    
  }

  const validateThis = () => {
    if (logComponent('IntegerInput')) { console.debug('IntegerInput validateThis'); }

    let rulesToCheck = Object.assign({}, rules);

    if (rules.required) {
      rulesToCheck.validInteger = true;
    }

    let validationDetails = {};

    for (let rule in rulesToCheck) {
     validationDetails[rule] = validate[rule](valueRef.current, rulesToCheck[rule]);
    }

    let isValidLocal = Object.values(validationDetails).reduce((prev, curr) => prev && curr, true);

    setValidationDetails(validationDetails);
    setIsValid(isValidLocal);



    onValidate({
      name: name,
      isValid: isValidLocal,
      value: valueRef.current
    });  
  }  

  const handleBlur = () => {
    if (logComponent('IntegerInput')) { console.debug('IntegerInput handleBlur'); }
    validateThis();
  }

  return (
    <div className="Integer-Input-Group">
    {
      showError && !fieldIsValid &&
      errorMessages.map((message, index) => {
        return <p key={index} className="Decimal-Input-Group__error">{message}</p>; 
      })
    }   
      <label 
        className="Integer-Input-Group__label"
        htmlFor={name + '-input'}>
              {label}{
        rules && rules.required &&
        <span className="Integer-Input-Group__required"> *</span>
}
      </label>
      <input 
        id={name + '-input'}
        className="Integer-Input-Group__input" 
        type="text"
        spellCheck="false"
        tabIndex={tabIndex}
        readOnly={readOnly}
        value={value}
        onChange={updateValue}
        onBlur={handleBlur} />
      { 
        instructions &&
        <span className="Integer-Input-Group__instructions">{ instructions }</span>
      }      
    </div>
  );
}